import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { fg } from '@atlaskit/platform-feature-flags';
import AbstractVCCalculatorBase from '../abstract-base-vc-calculator';
import isViewportEntryData from '../utils/is-viewport-entry-data';
var ABORTING_WINDOW_EVENT = ['wheel', 'scroll', 'keydown', 'resize'];
var REVISION_NO = 'fy25.03';
var getConsideredEntryTypes = function getConsideredEntryTypes() {
  var entryTypes = ['mutation:child-element', 'mutation:element', 'mutation:attribute', 'layout-shift', 'window:event'];

  // If not exclude 3p elements from ttvc,
  // including the tags into the ConsideredEntryTypes so that it won't be ignored for TTVC calculation
  if (!fg('platform_ufo_exclude_3p_elements_from_ttvc')) {
    entryTypes.push('mutation:third-party-element');
  }
  if (fg('platform_ufo_enable_media_for_ttvc_v3')) {
    entryTypes.push('mutation:media');
  }
  return entryTypes;
};

// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
export var KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS = ['data-drop-target-for-element', 'data-drop-target-for-external', 'draggable'];

// Common aria attributes that don't cause visual layout shifts
export var NON_VISUAL_ARIA_ATTRIBUTES = ['aria-label', 'aria-labelledby', 'aria-describedby', 'aria-hidden', 'aria-expanded', 'aria-controls', 'aria-selected', 'aria-checked', 'aria-disabled', 'aria-required', 'aria-current', 'aria-haspopup', 'aria-pressed', 'aria-atomic', 'aria-live'];
var VCCalculator_FY25_03 = /*#__PURE__*/function (_AbstractVCCalculator) {
  function VCCalculator_FY25_03() {
    _classCallCheck(this, VCCalculator_FY25_03);
    return _callSuper(this, VCCalculator_FY25_03, [REVISION_NO]);
  }
  _inherits(VCCalculator_FY25_03, _AbstractVCCalculator);
  return _createClass(VCCalculator_FY25_03, [{
    key: "isEntryIncluded",
    value: function isEntryIncluded(entry) {
      if (!getConsideredEntryTypes().includes(entry.data.type)) {
        return false;
      }
      if (entry.data.type === 'mutation:attribute') {
        var entryData = entry.data;
        var attributeName = entryData.attributeName;
        if (!attributeName || KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS.includes(attributeName)) {
          return false;
        }
        if (attributeName.startsWith('data-test') && fg('platform_ufo_ttvc_exclude_data_test_attribute') || attributeName === 'data-aui-version' || attributeName === 'data-testid' || attributeName === 'data-vc' || attributeName === 'data-ssr-placeholder' || attributeName === 'data-ssr-placeholder-replace' || attributeName === 'data-vc-nvs' || attributeName === 'data-media-vc-wrapper' || attributeName === 'data-renderer-start-pos' || attributeName === 'data-table-local-id' || attributeName === 'spellcheck' || attributeName === 'data-auto-scrollable' || attributeName === 'id' || attributeName === 'tabindex' || attributeName === 'data-is-ttvc-ready' || NON_VISUAL_ARIA_ATTRIBUTES.includes(attributeName)) {
          return false;
        }
        return true;
      }
      if (isViewportEntryData(entry.data) && !entry.data.visible) {
        return false;
      }
      return true;
    }
  }, {
    key: "getVCCleanStatus",
    value: function getVCCleanStatus(filteredEntries) {
      var dirtyReason = '';
      var hasAbortEvent = filteredEntries.some(function (entry) {
        if (entry.data.type === 'window:event') {
          var data = entry.data;
          if (ABORTING_WINDOW_EVENT.includes(data.eventType)) {
            dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
            return true;
          }
        }
        return false;
      });
      if (hasAbortEvent && dirtyReason) {
        return {
          isVCClean: false,
          dirtyReason: dirtyReason
        };
      }
      return {
        isVCClean: true
      };
    }
  }]);
}(AbstractVCCalculatorBase);
export { VCCalculator_FY25_03 as default };